import React from "react";
import styled from "styled-components";
import { Modal } from "@/components/modal/modal";
import { useDispatch } from "react-redux";
import { addInstagramSuggestionModal } from "../__redux-model";
import { Link } from "react-router-dom";
import ReactPlayer from "react-player";
import { Button, FormSize } from "ui/ecosystems/forms";
import type { AppDispatch } from "types/redux-dispatch";

export function AddInstagramSuggestion(props: {
  isHidden: boolean;
}): React.ReactNode {
  const dispatch = useDispatch<AppDispatch>();

  function closeModal() {
    dispatch(addInstagramSuggestionModal.close);
  }

  return (
    <StyledModal show={!props.isHidden} onHide={closeModal}>
      <Modal.Header closeButton onHide={closeModal}>
        <Modal.Title>
          Add an Instagram account to use the Grid Preview!
        </Modal.Title>
        <Subtitle>
          Make your grid pop with our drag 'n' drop Instagram grid preview. Add
          an Instagram account to get planning!
        </Subtitle>
      </Modal.Header>
      <Content>
        <ReactPlayer src="https://youtu.be/2NL67K8vHe0" controls />
      </Content>
      <StyledModalFooter className="justify-center">
        <Link to="/dashboard/accounts">
          <Button size={FormSize.large} primary onClick={closeModal}>
            Take me to the Social Accounts page
          </Button>
        </Link>
      </StyledModalFooter>
    </StyledModal>
  );
}

const Subtitle = styled.p`
  margin: 8px 0 0 0;
  font-size: 14px;
  color: #454545;
`;

const Content = styled(Modal.Body)`
  display: flex;
  justify-content: center;
`;

const StyledModalFooter = styled(Modal.Footer)`
  padding-bottom: 55px;
`;

const StyledModal = styled(Modal)``;
